<template>
    <div class="creatAccount">
        <h2>Activate your account</h2>
        <p>Enter the activation code we sent to <span>{{$store.state.email}}</span>. If you don't see it, you can click <a @click="send" href="javascript:;">send again</a>.</p>
        <div class="form">
            <el-form :model="activateInfo" ref="accountForm" :rules="rule" @submit.native.prevent>
                <el-row>
                    <el-col :span="24">
                        <el-form-item
                            prop="verifyCode"
                            :rules="[{ required: true, message: 'please enter the activation code', trigger: 'blur' }]"
                        >
                            <el-input
                                v-model.trim="activateInfo.verifyCode"
                                placeholder="Enter the activation code"
                                :maxlength="30"
                                @keyup.enter.native="validateForm()"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <div class="btn clearfix">
            <span class="f_l" v-if="backBtn">
                <a @click="back">Back</a>
            </span>
            <el-button class="f_r" @click="validateForm" :disabled="isSendAjax">Activate</el-button>
        </div>
    </div>
</template>
<script>
import { gaAnalyze } from '@/assets/js/googleAnalyze/event.js';
export default {
    props:{
        backBtn: Boolean
    },
    data(){
        return{
            activateInfo:{},
            rule:{},
            errorCode: this.$store.state.errorCodeLink,
            sendBtn:false,
            isSendAjax:false,
        }
    },
    methods:{
        // 验证项
        validateForm() {
            // this.$emit('showModule',{type:'next',module:'complete',back:'activate'});
            // return;
            let flag = false
            this.$refs['accountForm'].validate((valid) => {
              flag = valid
            })

            gaAnalyze('lpActiveActive');
            if(flag){
                if(this.isSendAjax) return;
                this.isSendAjax = true;
                this.activateInfo.userId = this.$store.state.userId;
                this.activateInfo.service = 1;
                this.axios.post('/userGroup/user-group/rgUser/verify',this.activateInfo)
                .then(res => {
                    this.isSendAjax = false;
                    if(res.status == 200){                   
                        let linkName = this.errorCode[res.data.errorCode];
                        if(linkName){
                            this.$emit('showModule',{type:'next',module:linkName,back:'activate'});
                        }else{
                            this.$message.error(res.data.errorInfo)
                        }
                    }
                })
                // 成功跳转到compelete
                // 失败跳转到error
                
            }
        },
        send(){
            gaAnalyze('lpActiveSend');

            if(this.sendBtn){
                return;
            }
            this.sendBtn = true;
            this.axios.post('/userGroup/user-group/rgUser/sendVerifyCode',{
                userId: this.$store.state.userId,
                service: 1
                })
                .then(res => {
                    if(res.data.errorCode == '0x0'){
                        this.$message.success('send success')
                    }else{
                        this.$message.error('send error')
                    }
                    this.sendBtn = false;
                })
        },
        back(){
            gaAnalyze('lpActiveBack');
            this.$emit('showModule',{type:'back'})
        }
    }
}
</script>
<style lang="less" scoped>
h2{
    font-size: .28rem;
    font-weight: normal;
    margin-bottom: 0.17rem;
}
p{
    font-size: .16rem;
    margin-bottom: 0.35rem;
    a{
        color: #1EC345;
    }
}
.is-disabled{
    background: #6BCB82 !important;
}
.btn{
    position: relative;
    a{
        color: #1EC345;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
    }
}
@media(max-width:1024px){
    h2{
        font-size: .16rem;
        margin-bottom: .1rem;
    }
    p{
        font-size: .12rem;
        margin-bottom: 0.2rem;
    }
}
</style>

